import React, { useState } from "react";
import { CheckSquare, MapPin, Phone, Play, Pause } from "react-feather";
import { useQuery } from "react-query";
import { useParams } from "react-router-dom";
import { Container, Row, Col, Button } from "reactstrap";
import ReactHtmlParser from "react-html-parser";
import ReactPlayer from "react-player";

import { HeaderSection } from "../../components/shared/HeaderSection";
import { GalleryImages } from "../../components/tourism/GalleryImages";
import { MapTourist } from "../../components/tourism/MapTourist";
import { ServerPlants } from "../../components/tourism/ServerPlants";
import { SubTitle } from "../../components/shared/SubTitle";

import { getTouristServersById } from "../../services/tourismService";

import ROUTES from "../../routes/routes";

const ServerDetail = () => {
  const [playing, setPlaying] = useState(true);
  const { id } = useParams();

  const { data, isError, isLoading, isFetching } = useQuery(
    ["server", id],
    () => getTouristServersById(id)
  );

  if (isLoading) return <p>Cargando</p>;
  if (isFetching) return <p>Loading feaching...</p>;
  if (isError) return <p>error</p>;

  const serverTouristPlant = data.servers_tourist_plant;

  return (
    <>
      <section
        id="intro-detail"
        style={{
          backgroundImage: `url(${data.image})`,
          backgroundRepeat: "no-repeat",
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        <HeaderSection
          route={ROUTES.SERVERS}
          resume="Volver a Servidores Túristicos"
          style={{ borderColor: "#1199B3" }}
        />
        <div className="box-title">
          <h1>{data.name}</h1>
          <small>
            {data.type_tourist_plant.name} -{" "}
            {data.type_tourist_plant.get_type_display}
          </small>
        </div>
      </section>
      <Container>
        <Row>
          <Col md="12 pt-3">
            {ReactHtmlParser(data.content)}
            {data.link_platform && data.platform === 2 ? (
              <>
                <div id="cont-video">
                  <div className="video-hidden-publicity" />
                  <ReactPlayer
                    url={data.link_platform}
                    playing={playing}
                    style={{ margin: "1% auto" }}
                  />
                </div>
                <div id="cont-btn-video">
                  {playing ? (
                    <Button color="info" onClick={() => setPlaying(false)}>
                      <Pause size={15} />
                    </Button>
                  ) : (
                    <Button color="info" onClick={() => setPlaying(true)}>
                      <Play size={15} />
                    </Button>
                  )}
                </div>
              </>
            ) : null}

            <hr />
            <SubTitle title="Galería de Fotos" position="text-center" />
            <GalleryImages images={data.gallery_base_tourist} />
            <hr />
            <SubTitle title="Ubicación" position="text-center" />
            <section className="cont-address">
              <div id="box-description-address">
                <p className="text-capitalize">
                  <MapPin size={14} />
                  {data.main_street}, {data.parish.nombre}
                </p>
                <hr />
                <p>
                  <Phone size={14} /> +593 {data.phone}
                </p>
              </div>
              <MapTourist
                lat={data.latitude}
                lng={data.longitude}
                zoom={18}
                width={"100%"}
                height={500}
              />
              <div className="map-hidden-publicity" />
            </section>

            <hr />
            <SubTitle title="Servicios" position="text-center" />
            <Row>
              {data.services.map((service, index) => (
                <Col md="6" key={index}>
                  <p>
                    <CheckSquare
                      size="14"
                      color="#6CC139"
                      style={{ marginRight: "5px" }}
                    />
                    {service.name}
                  </p>
                </Col>
              ))}
            </Row>
            {serverTouristPlant.length > 0 ? (
              <>
                <hr />
                <ServerPlants plants={serverTouristPlant} />
              </>
            ) : null}
          </Col>
        </Row>
      </Container>
      <HeaderSection
        route={ROUTES.SERVERS}
        resume="Volver a Servidores Túristicos"
        style={{ borderColor: "#1199B3" }}
      />
    </>
  );
};

export default ServerDetail;
